import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlannerElement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 85,
	height: 36,
	viewBox: "0 0 85 36",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			transform: "matrix(-1 0 0 1 66.008 30.13)",
			fill: "gray",
			r: 1.963
		}),
		/* @__PURE__ */ _jsx("circle", {
			transform: "matrix(-1 0 0 1 79.234 9.962)",
			fill: "current",
			r: 1.963
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.771 9.962a1.463 1.463 0 1 0 2.926 0 1.463 1.463 0 0 0-2.926 0Z",
			stroke: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			opacity: .497,
			d: "M77.278 33.974c0 .407.338.747.754.747h5.506c.417 0 .755-.34.755-.747V28.5a.754.754 0 0 0-.755-.747h-5.506a.754.754 0 0 0-.754.747v5.473Z",
			stroke: "gray",
			strokeOpacity: .38
		}),
		/* @__PURE__ */ _jsx("circle", {
			transform: "matrix(1 0 0 -1 18.785 6.526)",
			fill: "gray",
			r: 1.963
		}),
		/* @__PURE__ */ _jsx("circle", {
			transform: "matrix(1 0 0 -1 22.234 33.963)",
			fill: "current",
			r: 1.963
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.696 33.963a1.463 1.463 0 1 0-2.925 0 1.463 1.463 0 0 0 2.925 0Z",
			stroke: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			opacity: .497,
			d: "M7.515 2.024a.754.754 0 0 0-.755-.747H1.254a.754.754 0 0 0-.754.747v5.473c0 .407.338.747.754.747H6.76c.417 0 .755-.34.755-.747V2.024Z",
			stroke: "gray",
			strokeOpacity: .38
		})
	]
});
export default SvgPlannerElement;
